export default __webpack_public_path__ + "static/media/arrow-down.a7bbb36c.svg";